const ipLocal = '192.168.56.1'
export default {

  //RUTAS IP produccion //ruta para traer evidencias  
//  endpoint: 'http://172.20.0.69:8787/sirep-apostar/index.php/',
//  endpointEntradasSalidas: `http://172.20.0.69:8787/sirep-apostar/index.php/EntradasSalidas`,
//  endpointEvidenciasCaso: `http://172.20.0.69:8787/sirep-apostar/casos/uploadCaso.php`,
//  endpointEvidencias: `http://172.20.0.69:8787/sirep-apostar/casos/upload.php`, //ruta para subir evidencias
//  endpointTraerEvidencias: `http://172.20.0.69:8787/sirep-apostar/index.php/callcenter/evidencias_caso`, //ruta para traer evidencias  

 //RUTAS IP //ruta para traer evidencias
  endpoint: 'https://bk-nova.apostar.com.co/sirep-apostar/index.php/',
  endpointEntradasSalidas: `https://bk-nova.apostar.com.co/sirep-apostar/index.php/EntradasSalidas`,
  ip: 'https://bk-nova.apostar.com.co',
  ip2: 'https://nova.apostar.com.co',
  endpointEvidenciasCaso: `https://bk-nova.apostar.com.co/sirep-apostar/casos/uploadCaso.php`,
  endpointEvidencias: `https://bk-nova.apostar.com.co/sirep-apostar/casos/upload.php`, //ruta para subir evidencias
  endpointTraerEvidencias: `https://bk-nova.apostar.com.co/sirep-apostar/index.php/callcenter/evidencias_caso`, //ruta para traer evidencias

  // /**Rutas para probar local */
  // endpoint: `http://${ipLocal}/Nova-Back/index.php/`,
  // endpointEntradasSalidas: `http://${ipLocal}/Nova-Back/index.php/EntradasSalidas`,
  // endpointEvidenciasCaso: `http://${ipLocal}/Nova-Back/casos/uploadCaso.php`,
  // endpointEvidencias: `http://${ipLocal}/Nova-Back/casos/upload.php`, //ruta para subir evidencias
  // endpointTraerEvidencias: `http://${ipLocal}/Nova-Back/index.php/callcenter/evidencias_caso`, //ruta para traer evidencias 
}